<template>
  <div id="video_view" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="contentViewLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content" style="background:none;border: none;">
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="embed-responsive embed-responsive-16by9 position-relative" style="border-radius: 8px; overflow: hidden;">
                <video width="320" height="240"
                       class="embed-responsive-item"
                       controls
                       oncontextmenu="return false;"
                       controlsList="nodownload"
                       :src="src">
                </video>
                
                <!-- Creator Info & Description Overlay (Top for Video to avoid controls) -->
                <div v-if="influencer" class="media-info-overlay">
                  <div class="d-flex align-items-center mb-2" style="gap: 10px;">
                    <message-avatar :user-id="influencer.id" size="44px" class="shadow-sm" style="border: 2px solid rgba(255,255,255,0.2); border-radius: 50%; display: inline-flex;" />
                    <div class="text-white text-left">
                      <div class="font-weight-bold font-size-15" style="text-shadow: 0 1px 4px rgba(0,0,0,0.8);">{{ influencer.name }}</div>
                      <div v-if="description" class="font-size-13 mt-1" style="max-width: 90%; opacity: 0.9; text-shadow: 0 1px 4px rgba(0,0,0,0.8);">{{ description }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <button type="button"
                      class="close image-close-btn"
                      data-dismiss="modal"
                      aria-hidden="true"
                      @click="hide()">&times;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MessageAvatar from "@/components/module/shared/direct-message/MessageAvatar";

export default {
  name: "ModelVideoView",
  components: { MessageAvatar },
  data() {
    return {
      src: null,
      influencer: null,
      description: null
    }
  },
  methods: {
    show(src, influencer = null, description = null) {
      this.src = src;
      this.influencer = influencer;
      this.description = description;
      $('#video_view').modal('show');
      $('#video_view').off('hidden.bs.modal').on('hidden.bs.modal', () => {
        const videoElement = this.$el.querySelector('video');
        if (videoElement) {
          videoElement.pause();
          videoElement.currentTime = 0;
        }
      });
    },
    hide() {
      $('#video_view').modal('hide');
    }
  }
}
</script>

<style scoped>
.media-info-overlay {
  position: absolute;
  top: 0; left: 0; right: 0;
  padding: 16px 16px 40px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0) 100%);
  pointer-events: none;
  z-index: 15;
}
.image-close-btn{
  position: absolute;
  top: 5%;
  right: 4%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  color: Grey;
  padding: 12px 24px;
  cursor: pointer;
}
</style>
